export default __webpack_public_path__ + "static/media/banner-section.bd810172.svg";